import * as React  from 'react' ; 
import { isNull , cloneObject , ObjectUtils } from '../utils/index' ; 

export interface BaseComponentProps {}
export interface BaseComponentState {
    /**
     * ada error react pada component componentDidCatch atau tidak
     */
    haveReactError?: boolean ; 
    /**
     * data detail dari error
     */
    reactErrorData ?: {
        /**
         * data error raw
         */
        error: Error ;  
        /**
         * error info
         */
        errorInfo: React.ErrorInfo ;
    }; 
} 

/**
 * base class untuk component
 */
export class BaseComponent<PROPS extends BaseComponentProps, STATE extends BaseComponentState> extends React.Component<PROPS, STATE> {
    constructor(props: PROPS) {
        super(props) ; 
        this.state = {} as any ; 
    }
    /**
     * helper untuk update state. untuk mengurangi aktivitas clone state
     * @param updater method untuk update item-item yang berubah saja
     * @param afterSetStateTask setelah setstate selesai
     */
    setStateHelper ( updater: (clonedState: STATE ) => any , afterSetStateTask?: () => any  ): any  {
        this.setState( 
        ( prv: STATE ) => {
            let salin: STATE  = cloneObject(prv); 
            if ( isNull(salin)) {
                let s: any = {} ; 
                salin = s  ;
            }
            updater(salin);
            return salin ;
        } , 
        afterSetStateTask ); 
    }
    /**
     * versi async dari update state. agar code bisa sync
     * @param updater method untuk update state data
     */
    setStateHelperAsync (updater: (clonedState: STATE ) => any): Promise<any> {
        return new Promise<any> ( ( accept: (n: any ) => any , reject: (exc: any) => any ) => {
            this.setStateHelper( updater , () => {
                accept({}); 
            });
        }); 
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        const clsName: string =  (this as any).constructor.name ; 
        console.error(`[${clsName}componentDidCatch] report error : ` , error , '. info: ' , errorInfo);  
        this.setStateHelper( st => {
            st.haveReactError = true ; 
            st.reactErrorData  = {
                error: error , 
                errorInfo: errorInfo
            }; 
        }); 
    }
    /**
     * kalau ada 1 yang beda akan return true
     * @param fields field-field yang akan di compare
     * @param srcStateOrProp source props/state
     * @param comparedStateOrProp pembanding props/state
     */
    compareForShouldComponentUpdateStateOrProp ( fields: Array<string>  , srcStateOrProp: any , comparedStateOrProp: any ): boolean  {
        if ( !isNull(fields) && fields.length > 0 ) {
            for ( let f of fields) {
                let srcVal: any = srcStateOrProp[f] ;
                let destVal: any = comparedStateOrProp[f]; 
                if ( f.indexOf('.') >= 0) {// kalau ada . berarti read nested fields
                    srcVal = readNested(srcStateOrProp , f) ; 
                    destVal = readNested(comparedStateOrProp , f) ; 
                }
                if ( Array.isArray(srcVal) || Array.isArray(destVal)) {
                    return !ObjectUtils.compareFieldsArray( srcVal , destVal , []) ; 
                }
                if ( srcVal !== destVal) {
                    return true ; 
                }
            }
        }
        return false ; 
    }
    renderErrorPanel() {
        return (
            <div style={{borderWidth: '1px' , borderColor: 'red' , borderStyle: 'solid'}}>
                Error : {JSON.stringify(this.state.reactErrorData)}
            </div>
        ); 
    }
}

/**
 * read nested variable
 */
export function readNested ( variable: any , path: string ): any {
    try {
        if ( isNull(variable)) {
            return null ; 
        }
        if ( isNull(path) || path.length === 0) {
            return null ; 
        }
        if ( path.indexOf('.') === -1) {
            return variable[path] ; 
        }
        let arr: string [] = path.split('.');
        let currData: any = variable ;  
        for ( var p of arr ) {
            currData = currData[p] ; 
            if ( isNull(currData)) {
                return null ; 
            }
        }
        return currData ;
    } catch ( exc ) {
        console.warn('Gagal read data , error : ' , exc);
    }
}

/**
 * menaruh data dengan deep scan 
 */
export function setValueHelper ( variable: any , path: string , value: any )  {
    if ( isNull(variable)) {
        return  ; 
    }
    if ( path.indexOf('.') === -1) {
        variable[path] = value;
        return ;  
    }
    let arr: string [] = path.split('.');
    let ltstKey: string = arr[arr.length - 1] ;
    arr.splice(arr.length - 1 , 1);
    let currData: any = variable ;  
    for ( var p of arr ) {
        if ( isNull(currData[p])) {
             currData[p] = {};
        } 
        currData = currData[p] ;
    }
    currData[ltstKey] = value ; 
}


// WEBPACK FOOTER //
// ./src/base/BaseComponent.tsx